import axios from 'axios';

const axiosInstance = axios.create();
const postRequest = async (path, dataAndConfig) => {
  // Note: we are sending the 'data' and the 'config' on two different args (apparently this is not needed but was the only way to make it work)
  return axiosInstance.post(path, dataAndConfig?.data, dataAndConfig);
};
const getRequest = async (path, config) => {
  return axiosInstance.get(path, config);
};
const putRequest = async (path, dataAndConfig) => {
  return axiosInstance.put(path, dataAndConfig?.data, dataAndConfig);
};
const deleteRequest = async (path, config) => {
  return axiosInstance.delete(path, config);
};

export { deleteRequest, getRequest, postRequest, putRequest };
//# sourceMappingURL=axiosHelpers.js.map
